import React, { useState } from 'react'

// Chakra imports
import {
  Box,
  Flex,
  Grid,
  Link,
  Text,
  Button,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react'
import { AddIcon } from '@chakra-ui/icons'
import GalleryDashboard from './components/galleryDashboard'
import { CreateGalleryModal } from './components/CreateGalleryModal'

export default function Marketplace() {
  const [activeCategory, setActiveCategory] = useState('all')
  const { isOpen, onOpen, onClose } = useDisclosure()

  // Chakra Color Mode
  const textColor = useColorModeValue('secondaryGray.900', 'white')
  const textColorBrand = useColorModeValue('brand.500', 'white')
  const activeColor = useColorModeValue('gray.800', 'white')

  const getLinkStyle = category => ({
    color: activeCategory === category ? activeColor : textColorBrand,
    fontWeight: activeCategory === category ? '700' : '500',
    textDecoration: activeCategory === category ? 'underline' : 'none',
    cursor: 'pointer',
    me: { base: '20px', md: '34px' },
    onClick: () => setActiveCategory(category),
  })

  return (
    <Box pt={{ base: '180px', md: '80px', xl: '80px' }}>
      <Grid
        mb='20px'
        gridTemplateColumns='1fr'
        gap={{ base: '20px', xl: '20px' }}
        display={{ base: 'block', xl: 'grid' }}
      >
        <Flex
          flexDirection='column'
          gridArea={{ xl: '1 / 1 / 2 / 3', '2xl': '1 / 1 / 2 / 2' }}
        >
          <Flex direction='column'>
            <Flex
              mt='45px'
              mb='20px'
              justifyContent='space-between'
              direction={{ base: 'column', md: 'row' }}
              align={{ base: 'start', md: 'center' }}
            >
              <Text color={textColor} fontSize='2xl' ms='24px' fontWeight='700'>
                Gallery
              </Text>

              <Flex
                align='center'
                me='20px'
                ms={{ base: '24px', md: '0px' }}
                mt={{ base: '20px', md: '0px' }}
                wrap="wrap"
                gap={4}
              >
                <Flex align='center' display={{ base: "none", sm: "flex" }}>
                  <Link {...getLinkStyle('concert')}>Concert</Link>
                  <Link {...getLinkStyle('cultural')}>Cultural</Link>
                  <Link {...getLinkStyle('sports')}>Sports</Link>
                  <Link {...getLinkStyle('all')} me='0'>
                    All
                  </Link>
                </Flex>

                <Button
                  leftIcon={<AddIcon />}
                  colorScheme='brand'
                  size='sm'
                  borderRadius='12px'
                  onClick={onOpen}
                >
                  New Image
                </Button>
              </Flex>
            </Flex>

            {/* Mobile links */}
            <Flex align='center' mb={4} ms='24px' display={{ base: "flex", sm: "none" }}>
              <Link {...getLinkStyle('concert')}>Concert</Link>
              <Link {...getLinkStyle('cultural')}>Cultural</Link>
              <Link {...getLinkStyle('sports')}>Sports</Link>
              <Link {...getLinkStyle('all')} me='0'>
                All
              </Link>
            </Flex>

            <Box>
              <GalleryDashboard filterCategory={activeCategory} />
            </Box>
          </Flex>
        </Flex>
      </Grid>

      <CreateGalleryModal isOpen={isOpen} onClose={onClose} />
    </Box>
  )
}
